<nav class="header" aria-label="main navigation">
  <div class="header-container">
    <button
      class="nav-toggle focus-link"
      (click)="openSideNav()"
      aria-label="Toggle menu here">
      <span class="hamburger-menu-bar">
        <span></span>
        <span></span>
        <span></span>
      </span>
    </button>

    <span class="header-branding">
      <a [routerLink]="['/']" *ngIf="!isSideNavOpen" class="focus-link">
        <img
          alt="My Offers Hub homepage"
          class="header-logo"
          [ngClass]="getBrandLogoName()"
          [src]="logoImageUrl()" />
      </a>
    </span>
  </div>
</nav>
<mat-sidenav-container class="sidenav-container" [ngStyle]="style()">
  <mat-sidenav
    #sidenav
    mode="over"
    class="sidenav"
    (closedStart)="handleSideNavClose()"
    (openedStart)="handleSideNavOpen()">
    <div class="container" data-analytics-nav="shelf-menu">
      <div class="close-button-wrapper">
        <button
          class="close-button focus-link"
          aria-label="Close"
          (click)="closeSideNav()">
          <rd-shared-icon
            class="close-icon"
            [iconSymbol]="'icon-close'"
            [iconTheme]="'primary'"></rd-shared-icon>
        </button>
      </div>
      <div class="nav-container" *ngIf="isSideNavOpen">
        <div *ngFor="let link of sideNavLinks">
          <a
            class="focus-link"
            *ngIf="isExternalNavLink(link); else internalNavLink"
            [href]="link.url">
            {{ link.name | translate }}
          </a>
          <ng-template #internalNavLink>
            <a
              class="focus-link"
              [class.active]="isActiveNavLink(link)"
              [routerLink]="[link.url]"
              (click)="closeSideNav()"
              >{{ link.name | translate }}</a
            >
          </ng-template>
        </div>
        <hr />

        <div *ngFor="let link of sideNavManageLinks">
          <a
            class="focus-link"
            *ngIf="isExternalNavLink(link); else internalNavLink"
            [href]="link.url"
            >{{ link.name | translate }}</a
          >
          <ng-template #internalNavLink>
            <a
              class="focus-link"
              [class.active]="isActiveNavLink(link)"
              [routerLink]="link.url"
              (click)="closeSideNav()"
              >{{ link.name | translate }}</a
            >
          </ng-template>
        </div>
        <hr />

        <div *ngFor="let link of sideNavHelpLinks">
          <a
            class="focus-link"
            *ngIf="isExternalNavLink(link); else internalNavLink"
            [href]="link.url"
            >{{ link.name | translate }}</a
          >
          <ng-template #internalNavLink>
            <a
              class="focus-link"
              [routerLink]="link.url"
              (click)="closeSideNav()"
              >{{ link.name | translate }}</a
            >
          </ng-template>
        </div>
      </div>
    </div>
  </mat-sidenav>
</mat-sidenav-container>
